module.exports = __webpack_public_path__ + "img/total.37a275f5.svg";